
export enum BannerNotificationType
{
	Appointment = "appointment"
}
